import { apiClient } from './apiClient';

export interface Website {
  id: string;
  domain: string;
  public_key: string;
  is_active: boolean;
  last_event_at: string | null;
  created_at: string | null;
  updated_at: string | null;
}

export interface TrackingStatus {
  is_active: boolean;
  last_event_at: string | null;
  event_count_last_24h: number;
}

export interface TrackingScript {
  script: string;
  track_url: string;
  public_key: string;
}

export const websiteService = {
  getWebsite: (): Promise<Website> => apiClient.get('/website/'),

  updateDomain: (domain: string): Promise<Website> =>
    apiClient.patch('/website/', { domain }),

  getTrackingStatus: (): Promise<TrackingStatus> =>
    apiClient.get('/website/tracking-status/'),

  getTrackingScript: (): Promise<TrackingScript> =>
    apiClient.get('/website/tracking-script/'),

  regenerateKey: (): Promise<{ public_key: string; domain: string }> =>
    apiClient.post('/website/regenerate-key/', {}),
};
